module.exports = __webpack_public_path__ + "static/media/diners.e8bc0286.svg";